{
  "iframeWaitingMessage": "謝謝您的等候。再等幾會……",
  "otherOrganizations": "其他組織",
  "solutionIframe": "主要內容",
  "unloadPromptMessage": "您確定嗎?"
}
